import { Component } from '@angular/core';
import { MeasurementContext, SiUnits, UnitType, UsUnits } from 'src/app/shared/data/engineering-enums';
import { EngineeringToolsApiService } from 'src/app/shared/services/engineering-tools-api';
import { UnitConverterService } from 'src/app/shared/services/unit-converter.service';

@Component({
  selector: 'app-pipe-size',
  templateUrl: './pipe-size.component.html',
  styleUrl: './pipe-size.component.scss',
  standalone: false
})
export class PipeSizeComponent {
  constructor(
    private api: EngineeringToolsApiService,
    private unitConverter: UnitConverterService
  ) { }

  public MeasurementContext = MeasurementContext;

  ngOnInit() {
    this.api.CreateComponent("PipeSize")
      .subscribe(vm => {
        this.viewModel = vm;
        this.isLoaded = true;
      });
  }

  viewModel: any = {};
  isLoaded: boolean = false;
  isUsUnits: boolean = true;
 
  formatUnits(value: any, context: MeasurementContext, decimalPlaces: number) {
    // trim 0s and decimal place

    if (this.isUsUnits)
      return this.trimTrailingZeros(this.unitConverter.FormatUs(value, context, decimalPlaces, false));
    return this.trimTrailingZeros(this.unitConverter.FormatSi(value, context, decimalPlaces, false));
  }

  getUnitText(context: MeasurementContext) {
    if (this.isUsUnits)
      return this.unitConverter.GetUnitText(UsUnits.get(context) || UnitType.F);
    return this.unitConverter.GetUnitText(SiUnits.get(context) || UnitType.C);
  }

  trimTrailingZeros(str: string) {
    return str.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '');
  }

}
